/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TaskItemAreaDataDto } from './TaskItemAreaDataDto';
import {
    instanceOfTaskItemAreaDataDto,
    TaskItemAreaDataDtoFromJSON,
    TaskItemAreaDataDtoFromJSONTyped,
    TaskItemAreaDataDtoToJSON,
} from './TaskItemAreaDataDto';

/**
 * @type TaskItemAreaDtoTaskTypeData
 * 
 * @export
 */
export type TaskItemAreaDtoTaskTypeData = TaskItemAreaDataDto;


export function TaskItemAreaDtoTaskTypeDataFromJSON(json: any): TaskItemAreaDtoTaskTypeData {
    return TaskItemAreaDtoTaskTypeDataFromJSONTyped(json, false);
}

export function TaskItemAreaDtoTaskTypeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDtoTaskTypeData {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TaskItemAreaDataDtoFromJSONTyped(json, true) };
    return  TaskItemAreaDataDtoFromJSONTyped(json, true);
}

export function TaskItemAreaDtoTaskTypeDataToJSON(value?: TaskItemAreaDtoTaskTypeData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTaskItemAreaDataDto(value)) {
        return TaskItemAreaDataDtoToJSON(value as TaskItemAreaDataDto);
    }

    return {};
}

/**
 * Check if a given object implements the TaskItemAreaDtoTaskTypeData interface.
 */
export function instanceOfTaskItemAreaDtoTaskTypeData(value: any): value is TaskItemAreaDtoTaskTypeData {
    if (instanceOfTaskItemAreaDataDto(value)) return true;
    return false;
}

